export default __webpack_public_path__ + "static/media/walkingSanta.a447f8a1.gif";